import { SearchX } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/index.ts';
import { buttonClass, cx } from '../ui/index.ts';

/**
 * Catch-all 404 inside the Shell — Dispatch Deck rebuild (epic #897
 * PR 8, formerly the console-shared `createNotFound` factory
 * instantiation). A centered card: icon well, title (the page's one
 * `h1`), hint, and a primary link back to the dashboard.
 */
export function NotFound(): JSX.Element {
  const t = useT();
  return (
    <section
      data-testid="not-found-page"
      className="flex min-h-[60vh] items-center justify-center"
    >
      <div className="flex w-full max-w-md flex-col items-center gap-2 rounded-xl border border-line-soft bg-card px-8 py-12 text-center">
        <div className="mb-1 flex h-10 w-10 items-center justify-center rounded-lg bg-raised text-paper-low">
          <SearchX aria-hidden="true" className="h-5 w-5" />
        </div>
        <h1 className="m-0 text-title text-paper">{t('notfound.title')}</h1>
        <p className="m-0 max-w-sm text-dense text-paper-low">{t('notfound.body')}</p>
        <Link to="/dashboard" className={cx(buttonClass('primary'), 'mt-4')}>
          {t('notfound.cta')}
        </Link>
      </div>
    </section>
  );
}
